import { MULTI_SECTION_SHELF_TOP_GAP } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/header.figma';
import { addHeaderGapsShelf } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/headerShelf/addHeaderShelf';
import { addHeaderDescription } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerDescription.fullWidth';
import { addHeaderGaps } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerGaps.fullWidth';
import { addHeaderHero } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerHero.fullWidth';
import { addShelfDisplaceGaps } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/addShelfDisplaceGaps';
import { isEven, isOdd } from '@Utils/miscUtils';
import { pipeAsyncTransformer } from '@Utils/pipeAsync';
import pipeWith from 'ramda/src/pipeWith';

import type { ViewData } from '../../common/multisection.data';

export const addHeaderFullWidth = pipeWith(pipeAsyncTransformer, [
  addHeaderHero,
  addHeaderDescription,
  addHeaderGaps,
  addHeaderGapsShelf(MULTI_SECTION_SHELF_TOP_GAP),
  addShelfDisplaceGaps(isOdd),
  addShelfDisplaceGaps(isEven),
]) as (viewData: ViewData) => Promise<ViewData>;
